<template>
  <a-tooltip
    placement="right"
    overlayClassName="home-upload-tooltips my-tooltips"
    title="最多创建6个层级"
  >
    <div class="disabled-btn add_folder operation_btn" data-rlog="all_new_click">新建文件夹</div>
  </a-tooltip>
</template>
<style lang="scss">
.operation-wrapper .add_folder.disabled-btn {
  cursor: not-allowed;
  &:hover {
    box-shadow: none;
  }
}
</style>
